import '../../sass/EEBusiness/index.scss'

const modal = document.getElementById('EEBusinessFunnelModal')
const configNode = document.getElementById('EEBusinessFunnelConfig')

if (modal && configNode) {
    const QUIZ_HASH = '#find-your-package'
    const QUIZ_QUERY_PARAM = 'package_quiz'
    const SCROLL_BLOCK_KEYS = new Set(['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '])

    let config = {}
    try {
        config = JSON.parse(configNode.textContent || '{}')
    } catch (e) {
        config = {}
    }

    const texts = config.texts || {}
    const notesConfig = texts.notes || {}
    const packageCatalog = config.packages || {}
    const quizSteps = config.steps || {}
    const availableStepKeys = Object.keys(quizSteps)
    const availablePackageIds = Object.keys(packageCatalog)

    if (!availableStepKeys.length || !availablePackageIds.length) {
        // Missing required configuration.
    } else {

    const toast = document.getElementById('EEBusinessFunnelToast')
    if (modal.parentElement !== document.body) {
        document.body.appendChild(modal)
    }
    if (toast && toast.parentElement !== document.body) {
        document.body.appendChild(toast)
    }

    const quizScreen = modal.querySelector('.js-ee-business-screen-quiz')
    const resultScreen = modal.querySelector('.js-ee-business-screen-result')
    const restartQuizButton = modal.querySelector('.js-ee-business-restart-quiz')
    const restartQuizWrap = modal.querySelector('.EEBusiness-FunnelRetryWrap')
    const dialog = modal.querySelector('.EEBusiness-FunnelDialog')
    const quizTitle = modal.querySelector('#EEBusinessFunnelTitle')
    const quizSubtext = modal.querySelector('.js-ee-business-question-subtext')
    const quizOptions = modal.querySelector('.js-ee-business-question-options')
    const progressFill = modal.querySelector('.js-ee-business-progress-fill')
    const progressLabel = modal.querySelector('.js-ee-business-progress-label')
    const prevButton = modal.querySelector('.js-ee-business-prev')
    const nextButton = modal.querySelector('.js-ee-business-next')

    const resultTitle = modal.querySelector('.js-ee-business-result-title')
    const resultSubtext = modal.querySelector('.js-ee-business-result-subtext')
    const resultEyebrow = modal.querySelector('.js-ee-business-result-eyebrow')
    const primaryPackage = modal.querySelector('.js-ee-business-primary-package')
    const secondaryPackages = modal.querySelector('.js-ee-business-secondary-packages')
    const resultNotes = modal.querySelector('.js-ee-business-result-notes')
    const packagePreviewModal = modal.querySelector('.js-ee-business-package-preview-modal')
    const packagePreviewDialog = modal.querySelector('.EEBusiness-PackagePreviewDialog')
    const packagePreviewFallback = modal.querySelector('.js-ee-business-package-preview-fallback')
    const packagePreviewCard = modal.querySelector('.js-ee-business-package-preview-card')

    const contactForm = modal.querySelector('.js-ee-business-contact-form')
    const selectedPackageField = modal.querySelector('.js-ee-business-selected-package-field')
    const sourceField = modal.querySelector('.js-ee-business-source-field')
    const answersField = modal.querySelector('.js-ee-business-answers-field')
    const notesField = modal.querySelector('.js-ee-business-notes-field')
    const selectedPackageText = modal.querySelector('.js-ee-business-selected-package-text')
    const emailField = modal.querySelector('.js-ee-business-email-field')
    const submitButton = modal.querySelector('.js-ee-business-submit')
    const formError = modal.querySelector('.js-ee-business-form-error')
    const formSuccess = modal.querySelector('.js-ee-business-form-success')
    const turnstileContainer = modal.querySelector('.js-ee-business-turnstile')

    const state = {
        answers: {},
        flow: ['step1', 'step3', 'step4'],
        stepIndex: 0,
        selectedPackageId: null,
        source: 'quiz',
        submitting: false,
        captchaVerified: false,
        turnstileWidgetId: null,
        turnstileEnsureTimer: null,
    }

    let hideTimeout = null
    let previewHideTimeout = null
    let toastTimeout = null
    let isScrollLocked = false
    let touchStartY = 0

    function getText(key) {
        const value = texts[key]
        return typeof value === 'string' ? value : ''
    }

    function getTextOrFallback(key, fallback) {
        const value = getText(key)
        return value || fallback
    }

    function getStep(stepKey) {
        const step = quizSteps[stepKey]
        return step && typeof step === 'object' ? step : null
    }

    function escapeHtml(value) {
        return String(value ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;')
    }

    function escapeSelectorValue(value) {
        return String(value ?? '')
            .replace(/\\/g, '\\\\')
            .replace(/"/g, '\\"')
    }

    function buildUrlFromWindow(url) {
        return `${url.pathname}${url.search}${url.hash}`
    }

    function formatProgressLabel(current, total) {
        const template = getText('progressTemplate')
        return template
            .replace(':current', String(current))
            .replace(':total', String(total))
    }

    function setQuizUrlState() {
        const url = new URL(window.location.href)
        const hasState = url.searchParams.get(QUIZ_QUERY_PARAM) === '1'

        if (hasState && url.hash !== QUIZ_HASH) {
            return
        }

        url.searchParams.set(QUIZ_QUERY_PARAM, '1')
        if (url.hash === QUIZ_HASH) {
            url.hash = ''
        }

        window.history.pushState({}, document.title, buildUrlFromWindow(url))
    }

    function clearQuizUrlState() {
        const url = new URL(window.location.href)
        let changed = false

        if (url.searchParams.has(QUIZ_QUERY_PARAM)) {
            url.searchParams.delete(QUIZ_QUERY_PARAM)
            changed = true
        }

        if (url.hash === QUIZ_HASH) {
            url.hash = ''
            changed = true
        }

        if (changed) {
            window.history.replaceState({}, document.title, buildUrlFromWindow(url))
        }
    }

    function setScreen(screen) {
        quizScreen.hidden = screen !== 'quiz'
        resultScreen.hidden = screen !== 'result'
    }

    function getFlow() {
        const flow = ['step1']

        if (state.answers.step1 === 'start-company' && getStep('step2_start')) {
            flow.push('step2_start')
        } else if (state.answers.step1 === 'not-sure-guidance' && getStep('step2_uncertain')) {
            flow.push('step2_uncertain')
        }

        if (getStep('step3')) {
            flow.push('step3')
        }
        if (getStep('step4')) {
            flow.push('step4')
        }

        return flow
    }

    function syncFlow() {
        const currentStepKey = state.flow[state.stepIndex] || 'step1'
        state.flow = getFlow()

        const currentIndex = state.flow.indexOf(currentStepKey)
        state.stepIndex = currentIndex === -1 ? 0 : currentIndex
    }

    function openModal() {
        if (hideTimeout) {
            clearTimeout(hideTimeout)
        }

        lockPageScroll()
        modal.style.display = ''
        modal.setAttribute('aria-hidden', 'false')

        requestAnimationFrame(() => {
            modal.classList.add('Active')
        })
    }

    function isPackagePreviewOpen() {
        return !!(packagePreviewModal && packagePreviewModal.getAttribute('aria-hidden') === 'false')
    }

    function closeModal({clearHash = true} = {}) {
        modal.classList.remove('Active')
        modal.setAttribute('aria-hidden', 'true')
        closePackagePreview({immediate: true})
        unlockPageScroll()
        resetTurnstile()
        clearFormMessages()

        hideTimeout = setTimeout(() => {
            if (modal.getAttribute('aria-hidden') === 'true') {
                modal.style.display = 'none'
            }
        }, 220)

        if (clearHash) {
            clearQuizUrlState()
        }
    }

    function renderCurrentStep() {
        syncFlow()

        const stepKey = state.flow[state.stepIndex]
        const step = getStep(stepKey)
        if (!step) {
            return
        }

        const selectedValue = state.answers[stepKey] || ''

        quizTitle.textContent = step.title || ''
        quizSubtext.textContent = step.subtext || ''

        const progress = ((state.stepIndex + 1) / state.flow.length) * 100
        progressFill.style.width = `${progress}%`
        progressLabel.textContent = formatProgressLabel(state.stepIndex + 1, state.flow.length)

        quizOptions.innerHTML = (Array.isArray(step.options) ? step.options : []).map((option) => {
            const isSelected = selectedValue === option.value ? ' Selected' : ''
            return `<button type="button" class="EEBusiness-FunnelOption js-ee-business-option${isSelected}" data-value="${escapeHtml(option.value)}">${escapeHtml(option.label)}</button>`
        }).join('')

        prevButton.style.visibility = state.stepIndex === 0 ? 'hidden' : 'visible'
        nextButton.textContent = state.stepIndex === state.flow.length - 1
            ? getText('showRecommendationButton')
            : getText('nextButton')
        nextButton.disabled = !selectedValue
    }

    function startQuiz() {
        state.answers = {}
        state.stepIndex = 0
        state.flow = getFlow()
        state.source = 'quiz'
        state.selectedPackageId = null
        closePackagePreview()

        if (notesField) {
            notesField.value = ''
        }

        setScreen('quiz')
        clearFormMessages()
        resetContactForm()
        renderCurrentStep()
    }

    function resolveHasEResidency() {
        if (state.answers.step1 === 'already-e-resident') {
            return true
        }

        if (state.answers.step1 === 'become-e-resident') {
            return false
        }

        if (state.answers.step2_start === 'yes') {
            return true
        }

        if (state.answers.step2_start === 'no') {
            return false
        }

        return null
    }

    function getQuizRecommendation() {
        const prefersNotary = state.answers.step3 === 'notary'
        const prefersDIY = state.answers.step4 === 'diy'
        const hasEResidency = resolveHasEResidency()

        let primaryId = 'future-e-resident'
        if (prefersNotary) {
            primaryId = 'traditional'
        } else if (hasEResidency === true) {
            primaryId = 'e-resident'
        }

        const notSureCount = Object.values(state.answers)
            .filter((value) => value === 'not-sure' || value === 'not-sure-guidance')
            .length

        return {
            primaryId,
            highlightDIY: prefersDIY,
            highlightConsultation: notSureCount >= 2,
        }
    }

    function getDirectRecommendation(packageId) {
        return {
            primaryId: packageId,
            highlightDIY: false,
            highlightConsultation: false,
        }
    }

    function closePackagePreview({immediate = false} = {}) {
        if (!packagePreviewModal) {
            return
        }

        if (previewHideTimeout) {
            clearTimeout(previewHideTimeout)
            previewHideTimeout = null
        }

        packagePreviewModal.classList.remove('Active')
        packagePreviewModal.setAttribute('aria-hidden', 'true')

        const finalizeClose = () => {
            packagePreviewModal.hidden = true

            if (packagePreviewCard) {
                packagePreviewCard.innerHTML = ''
            }

            if (packagePreviewFallback) {
                packagePreviewFallback.hidden = true
                packagePreviewFallback.textContent = ''
            }
        }

        if (immediate) {
            finalizeClose()
            return
        }

        previewHideTimeout = window.setTimeout(() => {
            previewHideTimeout = null
            if (packagePreviewModal.getAttribute('aria-hidden') === 'true') {
                finalizeClose()
            }
        }, 220)
    }

    function getPackageCardSource(packageId) {
        const safePackageId = escapeSelectorValue(packageId)
        const trigger = document.querySelector(`.EEBusiness-PackagesGrid .js-ee-business-package-select[data-package-id="${safePackageId}"]`)
        if (!trigger) {
            return null
        }

        return trigger.closest('.Card')
    }

    function getPackageCardClone(packageId) {
        const sourceCard = getPackageCardSource(packageId)
        if (!sourceCard) {
            return null
        }

        const clone = sourceCard.cloneNode(true)
        clone.querySelectorAll('.js-ee-business-package-select').forEach((button) => {
            button.classList.remove('js-ee-business-package-select')
            button.classList.add('js-ee-business-package-preview-close')
            button.removeAttribute('data-package-id')
            button.setAttribute('href', '#')
        })

        return clone
    }

    function openPackagePreview(packageId) {
        if (!packagePreviewModal || !packagePreviewCard) {
            return
        }

        const cardClone = getPackageCardClone(packageId)
        packagePreviewCard.innerHTML = ''

        if (cardClone) {
            packagePreviewCard.appendChild(cardClone)
            if (packagePreviewFallback) {
                packagePreviewFallback.hidden = true
                packagePreviewFallback.textContent = ''
            }
        } else if (packagePreviewFallback) {
            packagePreviewFallback.textContent = getText('previewUnavailable')
            packagePreviewFallback.hidden = false
        }

        if (previewHideTimeout) {
            clearTimeout(previewHideTimeout)
            previewHideTimeout = null
        }

        packagePreviewModal.hidden = false
        packagePreviewModal.setAttribute('aria-hidden', 'false')
        requestAnimationFrame(() => {
            packagePreviewModal.classList.add('Active')
        })
    }

    function getRecommendationCardMarkup(packageId, {recommended = false, showReadMore = false} = {}) {
        const packageInfo = packageCatalog[packageId]
        if (!packageInfo) {
            return ''
        }

        const recommendedLabel = getText('recommendedBadge')
        const recommendedTag = recommended && recommendedLabel
            ? `<div class="EEBusiness-RecommendationBadge">${escapeHtml(recommendedLabel)}</div>`
            : ''
        const readMoreLabel = getText('readMoreButton')
        const readMoreButton = showReadMore && readMoreLabel
            ? `<button type="button" class="General--Button Bordered Small EEBusiness-RecommendationReadMore js-ee-business-package-preview-open" data-package-id="${escapeHtml(packageId)}">${escapeHtml(readMoreLabel)}</button>`
            : ''

        return `<article class="EEBusiness-RecommendationCard${recommended ? ' Recommended' : ''}">
            ${recommendedTag}
            <h4>${escapeHtml(packageInfo.displayName)}</h4>
            <p>${escapeHtml(packageInfo.description)}</p>
            <div class="Price">${escapeHtml(packageInfo.price)}</div>
            ${readMoreButton}
        </article>`
    }

    function getDecisionNotes(recommendation) {
        const notes = []
        if (recommendation.highlightConsultation && notesConfig.consultation) {
            notes.push(notesConfig.consultation)
        }
        if (recommendation.highlightDIY && notesConfig.diy) {
            notes.push(notesConfig.diy)
        }

        return notes
    }

    function getDecisionNotesMarkup(recommendation) {
        return getDecisionNotes(recommendation).map((note) => {
            const title = escapeHtml(note.title || '')
            const body = escapeHtml(note.body || '')

            return `<article class="EEBusiness-DecisionNote Highlighted">
                ${title ? `<h4>${title}</h4>` : ''}
                ${body ? `<p>${body}</p>` : ''}
            </article>`
        }).join('')
    }

    function getDecisionNoteCodes(recommendation) {
        return getDecisionNotes(recommendation)
            .map((note) => note.code)
            .filter((code) => typeof code === 'string' && code.length > 0)
    }

    function setSelectedPackage(packageId) {
        const packageInfo = packageCatalog[packageId]
        if (!packageInfo) {
            return
        }

        state.selectedPackageId = packageId
        selectedPackageField.value = packageId
        selectedPackageText.textContent = `${packageInfo.displayName} (${packageInfo.price})`
    }

    function renderRecommendation(recommendation, source = 'quiz') {
        closePackagePreview()
        state.source = source
        sourceField.value = source
        answersField.value = source === 'quiz' ? JSON.stringify(state.answers) : ''
        if (notesField) {
            notesField.value = source === 'quiz'
                ? JSON.stringify(getDecisionNoteCodes(recommendation))
                : ''
        }

        resultTitle.textContent = source === 'quiz' ? getText('resultTitleQuiz') : getText('resultTitleDirect')
        resultSubtext.textContent = source === 'quiz' ? getText('resultSubtextQuiz') : getText('resultSubtextDirect')
        if (resultEyebrow) {
            const showEyebrow = source === 'quiz'
            resultEyebrow.hidden = !showEyebrow
            resultEyebrow.style.display = showEyebrow ? '' : 'none'
        }

        if (source === 'quiz') {
            primaryPackage.innerHTML = getRecommendationCardMarkup(recommendation.primaryId, {recommended: true, showReadMore: true})
            secondaryPackages.innerHTML = ''
            resultNotes.innerHTML = getDecisionNotesMarkup(recommendation)
        } else {
            primaryPackage.innerHTML = ''
            secondaryPackages.innerHTML = ''
            resultNotes.innerHTML = ''
        }

        const showRetake = source === 'quiz'
        if (restartQuizWrap) {
            restartQuizWrap.hidden = !showRetake
            restartQuizWrap.style.display = showRetake ? '' : 'none'
        }
        if (restartQuizButton) {
            restartQuizButton.hidden = !showRetake
            restartQuizButton.style.display = showRetake ? '' : 'none'
        }

        setScreen('result')
        ensureTurnstileWidget()
        resetContactForm()
        setSelectedPackage(recommendation.primaryId)
    }

    function hasTurnstileToken() {
        const tokenField = contactForm.querySelector('input[name="cf-turnstile-response"]')
        return !!(tokenField && tokenField.value && tokenField.value.trim().length > 0)
    }

    function isEmailReady() {
        return !!(emailField.value && emailField.value.trim().length > 0 && emailField.checkValidity())
    }

    function updateSubmitState() {
        const captchaReady = state.captchaVerified || hasTurnstileToken()
        submitButton.disabled = state.submitting || !isEmailReady() || !captchaReady
    }

    function clearFormMessages() {
        formError.textContent = ''
        formError.style.display = 'none'
        formError.hidden = true
        formError.classList.add('display-none')

        formSuccess.textContent = ''
        formSuccess.style.display = 'none'
        formSuccess.hidden = true
        formSuccess.classList.add('display-none')
    }

    function ensureTurnstileWidget() {
        if (!turnstileContainer || state.turnstileWidgetId !== null) {
            return
        }

        if (!window.turnstile || typeof window.turnstile.render !== 'function') {
            if (state.turnstileEnsureTimer) {
                return
            }

            state.turnstileEnsureTimer = window.setTimeout(() => {
                state.turnstileEnsureTimer = null
                ensureTurnstileWidget()
            }, 180)
            return
        }

        const sitekey = turnstileContainer.dataset.sitekey || ''
        if (!sitekey) {
            return
        }

        state.turnstileWidgetId = window.turnstile.render(turnstileContainer, {
            sitekey,
            theme: turnstileContainer.dataset.theme || 'light',
            callback: function (token) {
                state.captchaVerified = !!token
                updateSubmitState()
            },
            'expired-callback': function () {
                state.captchaVerified = false
                updateSubmitState()
            },
            'error-callback': function () {
                state.captchaVerified = false
                updateSubmitState()
            },
        })

        updateSubmitState()
    }

    function resetTurnstile() {
        state.captchaVerified = false

        if (window.turnstile && typeof window.turnstile.reset === 'function' && state.turnstileWidgetId !== null) {
            window.turnstile.reset(state.turnstileWidgetId)
        }

        updateSubmitState()
    }

    function resetContactForm() {
        clearFormMessages()
        state.submitting = false
        emailField.disabled = false
        emailField.value = ''
        resetTurnstile()
    }

    function showFormError(message) {
        const normalizedMessage = typeof message === 'string' ? message.trim() : ''
        const visibleMessage = normalizedMessage || getTextOrFallback('formErrorGeneric', 'Something went wrong. Please try again.')

        formSuccess.style.display = 'none'
        formSuccess.hidden = true
        formSuccess.classList.add('display-none')

        formError.textContent = visibleMessage
        formError.hidden = false
        formError.classList.remove('display-none')
        formError.style.setProperty('display', 'block', 'important')

        if (typeof formError.scrollIntoView === 'function') {
            formError.scrollIntoView({behavior: 'smooth', block: 'nearest'})
        }
    }

    function showToast(message) {
        if (!toast || !message) {
            return
        }

        if (toastTimeout) {
            clearTimeout(toastTimeout)
        }

        toast.textContent = message
        toast.style.display = 'block'

        requestAnimationFrame(() => {
            toast.classList.add('Visible')
        })

        toastTimeout = setTimeout(() => {
            toast.classList.remove('Visible')
            setTimeout(() => {
                if (!toast.classList.contains('Visible')) {
                    toast.style.display = 'none'
                }
            }, 250)
        }, 4800)
    }

    function lockPageScroll() {
        if (isScrollLocked) {
            return
        }

        document.documentElement.classList.add('EEBusiness-ModalOpen')
        document.body.classList.add('EEBusiness-ModalOpen')

        document.addEventListener('wheel', onWheelLock, {passive: false})
        document.addEventListener('touchstart', onTouchStartLock, {passive: false})
        document.addEventListener('touchmove', onTouchMoveLock, {passive: false})
        document.addEventListener('keydown', onKeyDownLock, {passive: false})

        isScrollLocked = true
    }

    function unlockPageScroll() {
        if (!isScrollLocked) {
            return
        }

        document.documentElement.classList.remove('EEBusiness-ModalOpen')
        document.body.classList.remove('EEBusiness-ModalOpen')

        document.removeEventListener('wheel', onWheelLock)
        document.removeEventListener('touchstart', onTouchStartLock)
        document.removeEventListener('touchmove', onTouchMoveLock)
        document.removeEventListener('keydown', onKeyDownLock)
        isScrollLocked = false
    }

    function getActiveDialog() {
        if (isPackagePreviewOpen() && packagePreviewDialog) {
            return packagePreviewDialog
        }

        return dialog
    }

    function getScrollableParent(startElement, rootElement) {
        if (!rootElement) {
            return null
        }

        let el = startElement

        while (el && el !== rootElement && el !== document.body) {
            if (el instanceof HTMLElement) {
                const style = window.getComputedStyle(el)
                const canScroll = /(auto|scroll)/.test(style.overflowY) && el.scrollHeight > el.clientHeight
                if (canScroll) {
                    return el
                }
            }
            el = el.parentElement
        }

        if (rootElement.scrollHeight > rootElement.clientHeight) {
            return rootElement
        }

        return null
    }

    function canScroll(scrollElement, deltaY) {
        if (!scrollElement) {
            return false
        }

        if (deltaY < 0) {
            return scrollElement.scrollTop > 0
        }

        if (deltaY > 0) {
            return scrollElement.scrollTop + scrollElement.clientHeight < scrollElement.scrollHeight
        }

        return true
    }

    function shouldBlockScroll(target, deltaY) {
        const activeDialog = getActiveDialog()
        if (!activeDialog || !activeDialog.contains(target)) {
            return true
        }

        const scrollParent = getScrollableParent(target, activeDialog)
        return !canScroll(scrollParent, deltaY)
    }

    function onWheelLock(event) {
        if (!isScrollLocked) {
            return
        }

        if (shouldBlockScroll(event.target, event.deltaY)) {
            event.preventDefault()
        }
    }

    function onTouchStartLock(event) {
        if (!isScrollLocked || !event.touches || !event.touches.length) {
            return
        }

        touchStartY = event.touches[0].clientY
    }

    function onTouchMoveLock(event) {
        if (!isScrollLocked || !event.touches || !event.touches.length) {
            return
        }

        const touchY = event.touches[0].clientY
        const deltaY = touchStartY - touchY
        touchStartY = touchY

        if (shouldBlockScroll(event.target, deltaY)) {
            event.preventDefault()
        }
    }

    function isEditableElement(element) {
        if (!(element instanceof HTMLElement)) {
            return false
        }

        const tagName = element.tagName
        return element.isContentEditable || tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT'
    }

    function onKeyDownLock(event) {
        if (!isScrollLocked || !SCROLL_BLOCK_KEYS.has(event.key)) {
            return
        }

        if (isEditableElement(event.target)) {
            return
        }

        event.preventDefault()
    }

    async function responseToJson(response) {
        try {
            return await response.clone().json()
        } catch (e) {
            return {}
        }
    }

    function openQuizModal({updateHash = true} = {}) {
        startQuiz()
        openModal()

        if (updateHash) {
            setQuizUrlState()
        }
    }

    function openDirectPackageModal(packageId) {
        if (!packageCatalog[packageId]) {
            return
        }

        closePackagePreview()
        renderRecommendation(getDirectRecommendation(packageId), 'direct')
        openModal()
    }

    if (primaryPackage) {
        primaryPackage.addEventListener('click', (event) => {
            const trigger = event.target.closest('.js-ee-business-package-preview-open')
            if (!trigger) {
                return
            }

            event.preventDefault()
            const packageId = trigger.getAttribute('data-package-id')
            if (!packageId) {
                return
            }

            openPackagePreview(packageId)
        }, {passive: false})
    }

    if (packagePreviewModal) {
        packagePreviewModal.addEventListener('click', (event) => {
            const closer = event.target.closest('.js-ee-business-package-preview-close')
            if (!closer) {
                return
            }

            event.preventDefault()
            closePackagePreview()
        }, {passive: false})
    }

    quizOptions.addEventListener('click', (event) => {
        const option = event.target.closest('.js-ee-business-option')
        if (!option) {
            return
        }

        const stepKey = state.flow[state.stepIndex]
        state.answers[stepKey] = option.dataset.value

        if (stepKey === 'step1') {
            delete state.answers.step2_start
            delete state.answers.step2_uncertain
        }

        renderCurrentStep()
    })

    nextButton.addEventListener('click', () => {
        const stepKey = state.flow[state.stepIndex]
        if (!state.answers[stepKey]) {
            return
        }

        if (state.stepIndex === state.flow.length - 1) {
            renderRecommendation(getQuizRecommendation(), 'quiz')
            return
        }

        state.stepIndex += 1
        renderCurrentStep()
    })

    prevButton.addEventListener('click', () => {
        if (state.stepIndex === 0) {
            return
        }

        state.stepIndex -= 1
        renderCurrentStep()
    })

    emailField.addEventListener('input', () => {
        updateSubmitState()
    }, {passive: true})

    contactForm.addEventListener('submit', async (event) => {
        event.preventDefault()

        if (!state.selectedPackageId) {
            showFormError(getTextOrFallback('formErrorSelectPackage', 'Please choose a package before sending your request.'))
            return
        }

        clearFormMessages()
        const formData = new FormData(contactForm)
        formData.set('email', emailField.value.trim())
        formData.set('package', selectedPackageField.value)
        formData.set('source', sourceField.value)
        formData.set('quiz_answers', answersField.value)
        formData.set('quiz_notes', notesField ? notesField.value : '')

        state.submitting = true
        emailField.disabled = true
        updateSubmitState()

        try {
            const response = await fetch(contactForm.getAttribute('action'), {
                method: (contactForm.getAttribute('method') || 'POST').toUpperCase(),
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'xmlhttprequest',
                },
                body: formData,
            })

            const payload = await responseToJson(response)
            if (!response.ok) {
                let responseMessage = ''
                if (payload && typeof payload.message === 'string') {
                    responseMessage = payload.message.trim()
                }

                if (!responseMessage) {
                    try {
                        const responseText = await response.text()
                        responseMessage = responseText ? responseText.trim() : ''
                    } catch (e) {
                        responseMessage = ''
                    }
                }

                throw new Error(responseMessage || getTextOrFallback('formErrorResponseFallback', 'Please review your details and try again.'))
            }

            const successMessage = payload.message || getText('defaultSuccessMessage')

            if (window.dataLayer && Array.isArray(window.dataLayer)) {
                window.dataLayer.push({
                    event: 'ee-business-package-inquiry-sent',
                    package: state.selectedPackageId,
                    source: state.source,
                })
            }

            closeModal({clearHash: true})
            showToast(successMessage)
        } catch (error) {
            const errorMessage = error && typeof error.message === 'string'
                ? error.message
                : ''
            showFormError(errorMessage || getTextOrFallback('formErrorGeneric', 'Something went wrong. Please try again.'))
        } finally {
            state.submitting = false
            emailField.disabled = false
            resetTurnstile()
        }
    })

    if (restartQuizButton) {
        restartQuizButton.addEventListener('click', () => {
            startQuiz()
        }, {passive: true})
    }

    document.querySelectorAll('.js-ee-business-open-quiz').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault()
            openQuizModal({updateHash: true})
        }, {passive: false})
    })

    document.querySelectorAll('.js-ee-business-package-select').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault()
            openDirectPackageModal(trigger.dataset.packageId)
        }, {passive: false})
    })

    modal.querySelectorAll('.js-ee-business-close').forEach((closer) => {
        closer.addEventListener('click', () => {
            closeModal({clearHash: true})
        }, {passive: true})
    })

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
            if (isPackagePreviewOpen()) {
                closePackagePreview()
                return
            }

            closeModal({clearHash: true})
        }
    })

    window.addEventListener('hashchange', () => {
        if (window.location.hash === QUIZ_HASH && modal.getAttribute('aria-hidden') === 'true') {
            openQuizModal({updateHash: true})
        }
    })

        const searchParams = new URLSearchParams(window.location.search)
        if (window.location.hash === QUIZ_HASH || searchParams.get(QUIZ_QUERY_PARAM) === '1') {
            openQuizModal({updateHash: true})
        }
    }
}
